import type { CalendarEventDto } from '../../api/calendar';

/**
 * ⭐ 반복 회차의 바로 앞·뒤 회차 «보이는 시작» (2026-10-14 · 반복 규칙 1단계 B).
 *
 * 화면이 불러온 목록에서 같은 시리즈(같은 id)의 회차를 원래 회차 시각(occurrenceAt) 순으로 보고 이웃을 고른다.
 * ⚠ 불러온 범위 밖이나 나뉜 다른 조각(다른 id)은 모른다 — 그때는 null 이고 서버가 최종 판정한다.
 */
export function occurrenceNeighborsIn(
  events: readonly Pick<CalendarEventDto, 'id' | 'occurrenceAt' | 'startAt'>[],
  target: Pick<CalendarEventDto, 'id' | 'occurrenceAt' | 'recurrenceRule'> | null | undefined,
): { prev: string | null; next: string | null } | null {
  if (!target?.recurrenceRule || !target.occurrenceAt) return null;
  const key = Date.parse(target.occurrenceAt);
  if (Number.isNaN(key)) return null;
  let prev: { k: number; at: string } | null = null;
  let next: { k: number; at: string } | null = null;
  for (const ev of events) {
    if (ev.id !== target.id || !ev.occurrenceAt) continue;
    const k = Date.parse(ev.occurrenceAt);
    if (Number.isNaN(k) || k === key) continue;
    if (k < key && (!prev || k > prev.k)) prev = { k, at: ev.startAt };
    if (k > key && (!next || k < next.k)) next = { k, at: ev.startAt };
  }
  return { prev: prev?.at ?? null, next: next?.at ?? null };
}
